import { OnInit, Input,ViewChild } from '@angular/core';
import { AppPageTemplate } from '../../../model/xmlconfig/app.page.template';
import { AppPageElement } from '../../../model/xmlconfig/app.page.element';
// import { BaseCase} from '../../basecase';
export class GridBaseCase implements OnInit  {
    @Input()
    template: AppPageTemplate = new AppPageTemplate();//表示单独的Template
    @Input()
    element: AppPageElement = new AppPageElement();//表示xml对应的Element节点对象
    @Input()
    config: Array<AppPageElement> = new Array<AppPageElement>();//表示Element节点数组
    @Input()
    type: string;//模块类型
    @Input()
    ConfigName: any;//表示template节点下Content节点的ConfigName；
    @ViewChild('ionRefresh') ionRefresh;

    fieldItem = {};//所需数据字段
    gridDataList: Array<any> = new Array<any>();//获取数据源
    listData:Array<any> = new Array<any>();//获取数据源
    loading: boolean = false;//加载效果
    formObject = {key:{text:"",value:""}};//
    PageNumber = 1;
    gridSerchData:Array<any> = new Array<any>();//搜索待会数据操作
    apiObj = {
        status: false,
        msg: ''
    };//接口状态
    constructor() {
    }
    ngOnInit() {
     this.LoadData(1);
    }
    /**
     * 动态加载数据源,针对控件拉去列表数据时使用
     * @param PageNumber 当前页数 默认 1
     * @param doRefresh 是否下拉刷新 默认 false
     */
    LoadData(PageNumber,doRefresh:boolean = false){

    }
    /**
   * 下拉刷新数据
   * @param event
   */
  doRefresh(event){
    this.LoadData(1,true);
    // console.log(event);
    event.target.pullMax=500;
    event.target.pullMin=100;
    // console.log(this.ionRefresh);
    event.target.complete();
  }

}